/** @format */

import React, { useState } from 'react'
import { _$, Tabs, Tab, Card } from '@king-design/react'
import { useLocation } from 'react-router-dom'
import TacticsList from 'src/containers/MonitorAlarmTactics/TacticsList'
import EventList from 'src/containers/MonitorAlarmTactics/AlarmEventList'
import MonitorCrumb from 'src/components/MonitorCrumb'

// 告警策略
const TacticsTabs = [
  {
    text: _$('阈值告警'),
    value: 'threshold'
  },
  {
    text: _$('事件告警'),
    value: 'event'
  }
]
const MonitorAlarmTactics = () => {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const tab = searchParams.get('tab')
  const [currentTab, setTab] = useState(tab || 'threshold')

  return (
    <div>
      <MonitorCrumb breadArr={[{ title: _$('告警服务') }, { title: _$('告警策略') }]} />
      <Card>
        <Tabs
          value={currentTab}
          onChangeValue={tab => {
            setTab(tab)
            window.history.pushState(null, '', `/#!/monitor/alarmServer/rule/home?tab=${tab}`)
          }}
        >
          {TacticsTabs.map(({ text, value }) => (
            <Tab key={value} value={value}>
              {_$(text)}
            </Tab>
          ))}
        </Tabs>
        <div>{currentTab === 'threshold' ? <TacticsList /> : null}</div>
        <div>{currentTab === 'event' ? <EventList /> : null}</div>
      </Card>
    </div>
  )
}

export default MonitorAlarmTactics
